import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

const Nav = () => {
  return (
    <>
      <Link to="/">
        <Button variant="primary">Home</Button>
      </Link>
      <Link to="/projects">
        <Button variant="outline">View Projects</Button>
      </Link>
      <Link to="/calendar">
        <Button variant="outline">Calendar</Button>
      </Link>
      <Link to="/contact">
        <Button variant="outline">Contact Me</Button>
      </Link>
    </>
  );
};

export default Nav;
